import { APP_DNEVNIK, APP_CAFETERIA, APP_ACCESS, APP_POLLS, EXT_ELJUR } from 'app/common/constants/services';
import empty from 'app/common/images/empty.png';
import isProduction from 'app/common/lib/isProduction';

// DEPRECATED

const shopApiUrl = isProduction()
  ? 'https://apistore.sms-dnevnik.com/api/'
  : 'https://apistore0.sms-dnevnik.com/api/';
// const shopApiUrl = 'https://new-lk0.sms-dnevnik.com/store/api/';
// const shopApiUrl = 'http://185.104.106.34:3001/api/';

// основной api
const apiUrl = isProduction()
  ? 'https://api.in-shkola.ru/rest/'
  : 'https://api0.sms-dnevnik.com/rest/';

// для теста на другом тестовом апи
const apiUrlReplace = {
  'new-lk2.sms-dnevnik.com': 'https://api2.sms-dnevnik.com/rest/',
  'new-lk.sms-dnevnik.com': 'https://api0.sms-dnevnik.com/rest/',
};

const wsUrl = isProduction()
  ? 'wss://new-lk0.sms-dnevnik.com/ws'
  : 'wss://new-lk0.sms-dnevnik.com/ws';

const ejLoginUrl = isProduction()
  ? `https://auth.eljur.ru/auth/innovat/?redirect=${document.location.origin}/eljur`
  : `https://auth.eljur.ru/auth/innovat-test/?redirect=${document.location.origin}/eljur`;

const ejApiUrl = isProduction()
  ? `${document.location.origin}/eljur/api/`
  : 'https://new-lk0.sms-dnevnik.com/eljur/api/';

// для теста на другом тестовом апи
const ejApiUrlReplace = {
  'new-lk2.sms-dnevnik.com': 'https://new-lk2.sms-dnevnik.com/eljur/api/',
};

// url для отдельного сервера в киргизии
// Нет тестового варианта
const apiUrlKG = 'https://api.elmektep.kg/rest/';

export default {
  shopApiUrl,
  apiUrl,
  apiUrlReplace,
  wsUrl,
  ejLoginUrl,
  ejApiUrl,
  ejApiUrlReplace,
  apiUrlKG,

  primaryColor: '#039be5',
  faintColor: '#e3f2fd',
  appType: 'cabinet',
  copyrightName: '',
  copyrightYear: new Date().getFullYear(),
  defaultLogo: empty,
  defaultLogoWhite: empty,
  downloadAppStore: {
    default: 'https://itunes.apple.com/ru/app/argus.skola/id1093116806?mt=8',
    'new-cabinet.myschool.spb.ru': 'https://itunes.apple.com/ru/app/%D0%BC%D0%BE%D1%8F-%D1%88%D0%BA%D0%BE%D0%BB%D0%B0-%D1%81%D0%BF%D0%B1/id1324948684?mt=8',
  },
  downloadGooglePlay: {
    default: 'https://play.google.com/store/apps/details?id=ru.innovat_llc.argus',
    'new-cabinet.myschool.spb.ru': 'https://play.google.com/store/apps/details?id=ru.rosohrana.diary',
  },
  updateInterval: 30 * 1000,
  maxItemsLoad: 500, // максимальное количество загружаемых данных (limit)
  perPageItems: 25, // количество элементов на одной странице
  perPageItemsVars: [25, 50, 100], // варианты выбора количества элементов на одной странице
  messageTimeout: 10 * 1000, // время существования сообщения для пользователя
  maxLessons: 8, // Максимальное количество уроков в день (Dnevik)
  dateFormat: 'YYYY-MM-DD', // формат даты в адресной строке
  dateFormatPresentative: 'DD.MM.YYYY', // формат даты при отображении данных
  monthFormat: 'YYYY-MM', // формат даты-месяца в адресной строке
  containerWidth: 1100, // ширина основного контейнера в приложении
  maxFiles: 3, // максимальное количество загружаемых файлов
  maxFileSize: 5242880, // максимальный размер загружаемого файла

  // Соответствие проходов символьным строкам
  // passages: {
  //   in: 'Вход',
  //   out: 'Выход',
  //   male: {
  //     in: 'Зашел в школу',
  //     out: 'Вышел из школы',
  //   },
  //   female: {
  //     in: 'Зашлa в школу',
  //     out: 'Вышла из школы',
  //   },
  //   androgynous: {
  //     in: 'Зашел в школу',
  //     out: 'Вышел из школы',
  //   },
  // },

  // Типы приложений
  // applications: {
  //   all: [APP_DNEVNIK, APP_CAFETERIA, APP_ACCESS, APP_POLLS],
  //   [APP_DNEVNIK]: { fullName: 'Электронный дневник', name: 'Дневник', type: 'Электронный' },
  //   [APP_CAFETERIA]: { fullName: 'Электронная столовая', name: 'Столовая', type: 'Электронная' },
  //   [APP_ACCESS]: { fullName: 'Электронная проходная', name: 'Проходная', type: 'Электронная' },
  //   [APP_POLLS]: { fullName: 'Электронный опросник', name: 'Опросник', type: 'Электронный' },
  // },

  // Описания для приложений (выводятся у отключенных)
  descriptions: {
    [APP_DNEVNIK]: 'Ежедневно наблюдайте за успеваемостью ребенка и контролируйте выполнение домашних заданий.',
    [APP_CAFETERIA]: 'Наблюдайте, сколько денег осталось у ребёнка после посещения столовой.',
    [APP_ACCESS]: 'Покажет вам когда ребенок входил и выходил из учебного заведения.',
    [APP_POLLS]: 'Принимайте участие в решении вопросов по развитию образовательного учреждения, в котором обучается ваш ребёнок.',
    [EXT_ELJUR]: 'Услуга «Электронный дневник» в школе, где обучается ваш ребенок, предоставляется компанией «ЭлЖур»',
  },

  // Типы обслуживания
  services: {
    lk: 'Личный кабинет',
    mobile: 'Мобильное приложение',
    sms: 'SMS',
    email: 'E-mail',
  },

  // Статусы опросов
  statuses: {
    active: 'Идет голосование',
    draft: 'Черновик',
    new: 'Новый',
    paused: 'Приостановлен',
    cancelled: 'Отменен',
    edited: 'Редактируется',
    ended: 'Завершен',
  },

  // Ошибки [не нужно?] используется только в Poll
  errors: {
    emptyField: 'Это поле обязательно к заполнению',
  },

  // Браузеры
  isFF: !!window.sidebar,
  isIE: window.navigator.msPointerEnabled
    || ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style),

};
